module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsShow__preview__box__p-41a7192700724cf4c6af4816d25ef263.svg";